import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ApplicationPath } from '@core/navigation/models/application-path.enum';
import { UserInfoFacade } from '@core/user-info/facades/user-info.facade';
import { TranslatePipe } from '@ngx-translate/core';
import { SpinnerComponent } from '@kaseya-design-components';

@Component({
  selector: 'itc-impersonate-banner',
  templateUrl: 'impersonate-banner.component.html',
  styleUrl: 'impersonate-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, SpinnerComponent],
})
export class ImpersonateBannerComponent {
  private readonly userInfoFacade = inject(UserInfoFacade);
  private readonly router = inject(Router);

  readonly spinnerColor = 'var(--text-black)';

  readonly userFullName = this.userInfoFacade.userFullName;
  readonly organizationName = this.userInfoFacade.organizationName;

  logOut(): void {
    this.router.navigateByUrl(ApplicationPath.Logout);
  }
}
